import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {ComputedTranche} from '../../../../components/dex/dex-streaming/types/computed/computed-tranche';
import {Side} from '../../../../enums/side';
import {
    DexTrancheDetailsStandaloneComponent
} from '../../standalone/dex-tranche-details-standalone/dex-tranche-details-standalone.component';

@Component({
    selector:      'dex-tranche-details-part',
    templateUrl:   './dex-tranche-details-part.component.html',
    styleUrls:     ['./dex-tranche-details-part.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DexTrancheDetailsStandaloneComponent
    ]
})
export class DexTrancheDetailsPartComponent {
    public tranche = input.required<ComputedTranche>();
    public isCollapsed = input.required<boolean>();
    public isExpandCollapseEnabled = input.required<boolean>();
    public readonly isSymbolClickable = input.required<boolean>();

    public readonly toggleCollapsed = output<void>();
    public readonly symbolClick = output<string>();
    public readonly tradeClick = output<Side>();

}
